import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { CompanyComment, HttpResponse } from "@/types";

export function useGetCompanyComments() {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: ["company-comments", currentCompanyId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/company-comments`;
      const res = await guacHttpClient.get<
        CompanyComment[],
        HttpResponse<CompanyComment[]>
      >(path);
      return res.data;
    },
  });
}
